import React, { useState, useEffect } from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import Game from './components/Game';
import Menu from './components/Menu';
import About from './components/About';
import Instructions from './components/Instructions';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import Contact from './components/Contact';
import AISelector from './components/AISelector';
import backgroundImage from './assets/images/background.png';

function GameRoute() {
  const { type } = useParams();
  const [playerColor, setPlayerColor] = useState(() => {
    // Initialize player color for AI games
    if (type === 'random' || type === 'normal') {
      return Math.random() < 0.5 ? 'black' : 'white';
    }
    return null;
  });
  const [aiType, setAiType] = useState(() => {
    // Initialize AI type for AI games
    if (type === 'random' || type === 'normal') {
      return type;
    }
    return null;
  });

  useEffect(() => {
    if (type === 'random' || type === 'normal') {
      // Update when type changes
      setPlayerColor(Math.random() < 0.5 ? 'black' : 'white');
      setAiType(type);
    } else {
      setPlayerColor(null);
      setAiType(null);
    }
  }, [type]);

  if (type === 'random' || type === 'normal') {
    return (
      <div className="h-full w-full">
        <Game
          gameMode="ai"
          playerColor={playerColor}
          aiType={aiType}
        />
      </div>
    );
  } else if (type === '2player') {
    return (
      <div className="h-full w-full">
        <Game
          gameMode="2player"
          playerColor={null}
          aiType={null}
        />
      </div>
    );
  }
  return null;
}

function AppContent() {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    // Start the animation sequence after a brief delay
    const timer = setTimeout(() => {
      setShowContent(true);
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{ backgroundImage: `url(${backgroundImage})` }}
      className={`bg-black bg-cover bg-center relative h-screen overflow-hidden`}
    >
      {/* Black overlay that fades out */}
      <div className="pointer-events-none absolute inset-0 bg-black animate-initialFade z-10" />

      {/* Main content */}
      <div
        className={`bg-black bg-opacity-30 backdrop-blur-[1px] h-full flex flex-col items-center justify-center`}
      >
        <Routes>
          <Route
            path="/about"
            element={
              <div className={`transition-all duration-400 ${showContent ? 'opacity-100' : 'opacity-0'}`}>
                <About />
              </div>
            }
          />
          <Route
            path="/instructions"
            element={
              <div className={`transition-all duration-400 ${showContent ? 'opacity-100' : 'opacity-0'}`}>
                <Instructions />
              </div>
            }
          />
          <Route
            path="/privacy-policy"
            element={
              <div className={`transition-all duration-400 ${showContent ? 'opacity-100' : 'opacity-0'}`}>
                <PrivacyPolicy />
              </div>
            }
          />
          <Route
            path="/terms-of-service"
            element={
              <div className={`transition-all duration-400 ${showContent ? 'opacity-100' : 'opacity-0'}`}>
                <TermsOfService />
              </div>
            }
          />
          <Route
            path="/contact"
            element={
              <div className={`transition-all duration-400 ${showContent ? 'opacity-100' : 'opacity-0'}`}>
                <Contact />
              </div>
            }
          />
          <Route
            path="/play/ai"
            element={
              <div className={`transition-all duration-400 ${showContent ? 'opacity-100' : 'opacity-0'}`}>
                <AISelector />
              </div>
            }
          />
          <Route
            path="/play/:type"
            element={<GameRoute />}
          />
          <Route
            path="/"
            element={
              <div className={`transition-all duration-400 ${showContent ? 'opacity-100' : 'opacity-0'}`}>
                <div className={`animate-slideDown ${showContent ? 'opacity-100' : 'opacity-0'}`}>
                  <Menu />
                </div>
              </div>
            }
          />
        </Routes>
      </div>
    </div>
  );
}

function App() {
  return <AppContent />;
}

export default App; 
